import {NgModule} from "@angular/core";

import {
  CreateALeaseDialogComponent
} from "@features/leasing/create-a-lease/create-a-lease-dialog/create-a-lease-dialog.component";
import {
  CreateASubLeaseDialogComponent
} from "@features/leasing/create-a-lease/create-a-sub-lease-dialog/create-a-sub-lease-dialog.component";
import {
  CurrentLeasesListComponent
} from "@features/leasing/current-leases/current-leases-list/current-leases-list.component";
import {ManageBookingComponent} from "@features/leasing/lease-bookings/manage-booking/manage-booking.component";
import {
  ManageSubleaseBookingComponent
} from "@features/leasing/lease-bookings/manage-sublease-booking/manage-sublease-booking.component";
import {
  LeaseDetailsDrawerComponent
} from "@features/leasing/lease-planning/lease-planning-view/lease-details-drawer/lease-details-drawer.component";
import {
  LeaseOccupancyComponent
} from "@features/leasing/lease-planning/lease-planning-view/lease-occupancy/lease-occupancy.component";
import {
  LeasePlanningViewComponent
} from "@features/leasing/lease-planning/lease-planning-view/lease-planning-view.component";
import {
  LeaseSpaceInfoPanelComponent
} from "@features/leasing/lease-planning/lease-planning-view/lease-space-info-panel/lease-space-info-panel.component";
import {
  PlannedLeasesListComponent
} from "@features/leasing/lease-planning/lease-planning-view/planned-leases-list/planned-leases-list.component";
import {
  RetailersPipelineComponent
} from '@features/leasing/lease-planning/lease-planning-view/retailers-pipeline/retailers-pipeline.component';
import {
  LeaseScheduleListComponent
} from "@features/leasing/lease-schedule/lease-schedule-list/lease-schedule-list.component";
import {LeaseDetailsComponent} from "@features/leasing/lease-view/lease-details/lease-details.component";
import {LeaseDocumentsComponent} from "@features/leasing/lease-view/lease-documents/lease-documents.component";
import {LeasePosSettingsComponent} from "@features/leasing/lease-view/lease-pos-settings/lease-pos-settings.component";
import {
  PaymentDevicesSettingsDialogComponent
} from '@features/leasing/lease-view/lease-pos-settings/payment-devices-settings-dialog/payment-devices-settings-dialog.component';
import {
  PosSoftwareSettingsDialogComponent
} from '@features/leasing/lease-view/lease-pos-settings/pos-software-settings-dialog/pos-software-settings-dialog.component';
import {
  LeaseRatesAndChargesComponent
} from "@features/leasing/lease-view/lease-rates-and-charges/lease-rates-and-charges.component";
import {LeaseShowcaseComponent} from "@features/leasing/lease-view/lease-showcase/lease-showcase.component";
import {LeaseSpaceRatesComponent} from "@features/leasing/lease-view/lease-space-rates/lease-space-rates.component";
import {
  AddASpaceDialogComponent
} from "@features/leasing/lease-view/lease-spaces/add-a-space-dialog/add-a-space-dialog.component";
import {LeaseSpacesComponent} from "@features/leasing/lease-view/lease-spaces/lease-spaces.component";
import {LeaseSubLeasesComponent} from "@features/leasing/lease-view/lease-sub-leases/lease-sub-leases.component";
import {LeaseTurnoverComponent} from "@features/leasing/lease-view/lease-turnover/lease-turnover.component";
import {LeaseViewComponent} from "@features/leasing/lease-view/lease-view.component";
import {AppSharedModule} from "@modules/app-shared.module";
import {AppCoreModule} from "@modules/app.core.module";
import {MaterialModule} from "@modules/material.module";
import {IndustrySelectComponent} from "@shared-components/industry-select/industry-select.component";
import {RetailerLookupComponent} from "@shared-components/retailer-lookup/retailer-lookup.component";
import {CrudTableComponent} from "@ui-kit/webkit/components/crud-table/crud-table.component";
import {CustomDateFilterComponent} from '@ui-kit/webkit/components/custom-date-filter/custom-date-filter.component';

const components = [
  AddASpaceDialogComponent,
  CreateALeaseDialogComponent,
  CurrentLeasesListComponent,
  LeaseDetailsComponent,
  LeaseDetailsDrawerComponent,
  LeaseDocumentsComponent,
  LeaseOccupancyComponent,
  LeasePlanningViewComponent,
  LeasePosSettingsComponent,
  LeaseRatesAndChargesComponent,
  LeaseScheduleListComponent,
  LeaseSpaceInfoPanelComponent,
  LeaseSpacesComponent,
  LeaseTurnoverComponent,
  LeaseViewComponent,
  PaymentDevicesSettingsDialogComponent,
  PlannedLeasesListComponent,
  PosSoftwareSettingsDialogComponent,
  RetailersPipelineComponent,
  CreateASubLeaseDialogComponent,
  LeaseSubLeasesComponent
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule,
    CustomDateFilterComponent,
    IndustrySelectComponent,
    LeaseShowcaseComponent,
    CrudTableComponent,
    ManageBookingComponent,
    RetailerLookupComponent,
    LeaseSpaceRatesComponent,
    ManageSubleaseBookingComponent
  ],
  declarations: [...components],
  exports: [...components],
  providers: []
})
export class FeatureLeasingModule {
}
